module.exports = __webpack_public_path__ + "img/ylmf.fae9b22e.jpg";